import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Timestamp from '../../../Timestamp';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './DateAndMatureIndicator.scss';
// TODO: probably want to rename this if/when published_date_at_top is merged
var DateAndMatureIndicator = function (_a) {
    var publishedTime = _a.publishedTime, isMature = _a.isMature, className = _a.className;
    var published_date_at_top = useFlag('published_date_at_top');
    var t = useTranslation().t;
    var isDisplayingPublishedTime = publishedTime && !published_date_at_top;
    if (!isMature && !isDisplayingPublishedTime) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], className) },
        isDisplayingPublishedTime && (React.createElement("span", null,
            t('deviation.details.published'),
            ': ',
            React.createElement(Timestamp, { timestamp: publishedTime, showTooltip: true }))),
        isDisplayingPublishedTime && isMature && (
        // that is indeed meant to be two spaces each side
        React.createElement("span", null, "\u00A0\u00A0|\u00A0\u00A0")),
        isMature && React.createElement("span", null, t('deviation.details.mature'))));
};
DateAndMatureIndicator.displayName = 'DateAndMatureIndicator';
export default DateAndMatureIndicator;
//# sourceMappingURL=DateAndMatureIndicator.js.map